// extracted by mini-css-extract-plugin
export default {"card":"V6-z","carousel":"W6-z"};